import script from "./IncomingCallPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomingCallPopup.vue?vue&type=script&setup=true&lang=js"

import "./IncomingCallPopup.vue?vue&type=style&index=0&id=1ccf656e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccf656e"]])

export default __exports__